<div class="face"
     [woa-css-var]="{
         '--google-pay-button-type': type(),
         '--google-pay-button-color': color()
     }">
    @if (isPassive()) {
        @if (isSandboxed()) {
            <iframe class="google-pay-button" #googlePayButtonContainer sandbox="allow-scripts" allow="payment"
                    src="assets/bridges/google-pay-bridge.html" (load)="onIframeLoad()"></iframe>
        } @else {
            <div class="google-pay-button" #googlePayButtonContainer></div>
        }
    } @else if (paymentModel.paymentProvider() === IntegratedPaymentProvider.TYRO) {
        <div id="tyro-google-pay-form-holder"></div>
    }
    @if (showSpinner() || showTyroSpinner() || showLoadingSpinner()) {
        <woa-spinner class="face-spinner"></woa-spinner>
    }
</div>
